import { useState } from "react";

const PostPreview = ({ value }) => {
  const [open, setOpen] = useState(false);

  const fileUrl = typeof value === "string" ? value : value?.file;
  const caption = typeof value === "object" ? value?.caption : "";
  const isVideo = fileUrl?.endsWith(".mp4") || fileUrl?.endsWith(".webm");

  return (
    <>
      {/* Always render <td> so table stays aligned */}
      <td onClick={() => fileUrl && setOpen(true)} style={{ cursor: fileUrl ? "pointer" : "default" }}>
        {fileUrl ? (
          isVideo ? (
            <video
              src={fileUrl}
              width="50"
              height="50"
              style={{ borderRadius: "50%" }}
              muted
            />
          ) : (
            <img
              src={fileUrl}
              alt="post"
              style={{ width: "50px", height: "50px", borderRadius: "50%" }}
            />
          )
        ) : null}
      </td>

      {/* Modal */}
      {open && fileUrl && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
            top: "50px",
          }}
        >
          <div className="modal-dialog modal-lg" style={{ maxHeight: "40%" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Image or Video Preview</h5>
                <button type="button" className="close" onClick={() => setOpen(false)}>
                  <span>&times;</span>
                </button>
              </div>

              <div className="modal-body text-center">
                {isVideo ? (
                  <video controls style={{ width: "100%", height: "300px", borderRadius: "10px" }}>
                    <source src={fileUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <img
                    src={fileUrl}
                    alt="Post Preview"
                    style={{
                      width: "550px",
                      height: "350px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                )}
                {caption && <p style={{ marginTop: "10px" }}>{caption}</p>}
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setOpen(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default PostPreview;
